export default __webpack_public_path__ + "static/media/006-cargo ship.cd229eee.svg";